import { useEffect, useState } from 'react';
import Loader from '../../../components/Loader';
import { Link, useParams } from 'react-router-dom';
import FilterTable from '../../../components/FilterTable';
import PageHeading from '../../../components/PageHeading';
import GetOwnerPortfolio from '../../../APIs/OwnerPortfolio/GetOwnerPortfolio';

export default function OwnerLandByProject() {
    const [ownerTempList, setOwnerTempList] = useState([]);
    const [investorList, setInvestorList] = useState([]);
    const { projectId } = useParams();
    const [loader, setLoader] = useState(1);

    const getInvestorPortfolio = async () => {
        setLoader(1);
        const response = await GetOwnerPortfolio(null, projectId);
        if (response.status === 1) {
            setLoader(0);
            setOwnerTempList(response?.responseValue);
            setInvestorList(response?.responseValue);
        }
        else {
            setOwnerTempList([]);
            setInvestorList([]);
            setLoader(0);
        }
    }

    useEffect(() => {
        getInvestorPortfolio();
    }, []);

    return (
        <>
            <div className='container-fluid landformconatiner p-4'>
                <div className='d-flex flex-column flex-md-row justify-content-between'>
                    <PageHeading pagename={(investorList[0]?.ownerName || '') + " Lands details of Project " + (investorList[0]?.projectName || '')} />
                    <div className='d-flex flex-row  gap-2'>

                        <div className="btn-group gap-2 flex ml-5 " role="group" aria-label="Basic radio toggle button group">
                            {/* <div className='row-md'>
                          <input type="radio" className="btn-check" name="btnradio" id="btnradio1" autoComplete="off" checked={isProject === 0} onChange={() => { setIsProject(0); getInvestorPortfolio(); }} />
                          <label className="btn btn-project" htmlFor="btnradio1">Project</label>
                           </div> */}
                            {/* <div className='row-md'>
                              <input type="radio" className="btn-check" name="btnradio" id="btnradio2" autoComplete="off" checked={isProject === 1} onChange={() => { setIsProject(1); getDealWiseInvestor(); }} />
                          <label className="btn btn-Individual" htmlFor="btnradio2">Individual</label>
                          </div> */}
                        </div>


                        <FilterTable tempList={ ownerTempList } tempListMethod={setOwnerTempList } originalList={investorList} isSearch={true} />
                    </div>

                </div>

                <div className='pt-4'>
                    <table className="table">
                        <thead>
                            <tr className='table-head'>
                                <th scope="col">Name</th>
                                <th scope="col">Khasra  No.</th>
                                <th scope="col">Land Area</th>
                                <th scope="col">Investment Stats</th>
                                <th scope="col">Pending Amount (₹)</th>
                                <th scope="col">Action</th>
                            </tr>
                        </thead>
                        <tbody className='table-body'>
                            {
                                ownerTempList?.length > 0 ? ownerTempList.map((val, ind) => {
                                    return (
                                        <tr key={ind}>
                                            <td>
                                                <div className='d-flex flex-row gap-2'>
                                                    <div style={{ width: "30px", height: "30px", backgroundColor: "#E4E4E4", borderRadius: "15px" }}></div>
                                                    <span className='d-flex flex-column gap-1'>
                                                        <label className='heading-project fw-semibold'>{val.ownerName}</label>
                                                    </span>
                                                </div>
                                            </td>
                                            <td>{val.khasraNo}</td>
                                            <td>{val.landArea} {val.unitName}</td>
                                            <td>
                                                <span style={{ color: 'red', marginRight: '10px' }}>{val.amountTobePaid}</span>
                                                <i className="fa-solid fa-arrow-down" style={{ color: 'red', marginRight: '20px' }}></i>
                                                <span style={{ color: 'green', marginLeft: '10px' }}>{val.givenAmount}</span>
                                                <i className="fa-solid fa-arrow-up" style={{ color: 'green', marginLeft: '5px' }}></i>
                                            </td>
                                            <td>{val.pendingAmount}</td>
                                            <td >
                                                <div class="dropdown dropend">
                                                    <i class="bi bi-three-dots-vertical " data-bs-toggle="dropdown" aria-expanded="false"></i>
                                                    <ul className="dropdown-menu mr-3">

                                                        <li><Link className="dropdown-item" to={`/investorportfoliooverview/Project/${val.payeeType}/${val.referenceId}/${val.ownerName}/${val.paidToId}/1/0/${val.projectName}/${true}`}>View Transaction Details</Link></li>

                                                    </ul>
                                                </div>
                                            </td>
                                        </tr>
                                    )
                                })
                                    : (<tr><td colSpan="6" className="text-center">No data available</td></tr>)
                            }
                        </tbody>
                    </table>
                </div>

            </div>
            <Loader show={loader} />

        </>
    )
}
